import React, { useContext, useEffect, useState } from "react";
import { useData } from "../../hooks/useData";
import { Alert, Card, CardProps, Divider, DividerProps, Skeleton, Typography, styled } from "@mui/material";
import { SearchContext } from "../../context/SearchContextProvider";
import { useTranslation } from "react-i18next";

const StyledResultCard = styled(Card)<CardProps>(({theme}) => ({
    background: `${theme?.palette?.primary?.light}`,
    margin: '1em 0', 
    fontSize: '0.85em',
    padding: '1em'
}));

const StyledDivider = styled(Divider)<DividerProps>(({theme}) => ({
    margin: '1em 0'
}));

interface Props {
    fileId: number

}

const SearchResult : React.FC<Props> = ({fileId}) => {
    const {t} = useTranslation("common");
    const {searchTerms} = useContext(SearchContext);
    
    const [textContent, setTextContent] = useState([] as Array<any>);
    const [noResult, setNoResult] = useState(undefined as string | undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined as string | undefined);
    const [analyzeDocumentsApiCall] = useData<{textContent: Array<any>}>(`analyze`, "POST", "application/json");

    useEffect(() => {
        if((!textContent || textContent.length === 0) && !loading && !error && fileId && searchTerms && searchTerms?.join("_") !== noResult) {
            setLoading(true);
            setNoResult("");
            analyzeDocumentsApiCall((data) => {
                data?.textContent && setTextContent(data?.textContent); 
                setNoResult(searchTerms.join("_"));
                setLoading(false);
            }, (err) => {
                setError(err);
                setLoading(false);
            }, {
                fileId: fileId,
                searchTerms: searchTerms
            });
        }
    }, [textContent, loading, error, analyzeDocumentsApiCall, fileId, searchTerms, noResult]);

    const highlightSearchTerms = (text: string) => {
        let newText = text;
        searchTerms.forEach(searchTerm => {
            const searchPattern = new RegExp(`(${searchTerm})`, "gi");
            newText = newText.replace(searchPattern, `<strong>$1</strong>`);
        });

        return newText;
    }

    return <>
    {loading === true && <Skeleton variant="rectangular" width="100%" height="3em" sx={{margin: "1em 0"}} />}
    {!loading && !error && textContent?.map((c:any) => <StyledResultCard>
        <div dangerouslySetInnerHTML={{"__html": `(...) ${highlightSearchTerms(c?.text)} (...)`}}></div>
        <StyledDivider />
        <Typography variant="body2" sx={{textAlign: "right"}}>{`${t("common.search.page")}: ${c?.page}`}</Typography>
    </StyledResultCard>)}
    {!loading && !error && textContent.length === 0 && <StyledResultCard>{t("common.search.noresult")}</StyledResultCard>}
    {!loading && error && <Alert sx={{margin: "1em 0"}} severity="error" variant="filled">{t("common.search.error")}</Alert>}
    </>
}

export default SearchResult;